module.exports = __webpack_public_path__ + "static/media/avatar.4aa6cf6c.jpg";